import UserProfile from "./UserProfile";
import Appearance from "./Appearance";
import Security from "./Security";
import DataManagement from "./DataManagement";
import About from "./About";

const Settings = () => {
    return (
        <div className="bg-neutral-100 dark:bg-neutral-900 min-h-screen">
            <div className="max-w-4xl mx-auto p-4 sm:p-6 lg:p-8">
                <h1 className="text-3xl font-bold text-neutral-900 dark:text-white mb-8">
                    Settings
                </h1>

                <div className="space-y-8">
                    <UserProfile />
                    <Appearance />
                    <Security />
                    <DataManagement />
                    <About />
                </div>
            </div>
        </div>
    );
};

export default Settings;
